import Vue from "vue";
import Vuex from "vuex";
import state from "@/store/state";
import mutations from "@/store/mutations";
import actions from "@/store/actions";
import getters from "@/store/getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});

store.watch(
  (state) => state.featureFlags,
  (newVal) => {
    store.commit(
      "SET_MINIMUM_CONTRACT_LENGTH",
      newVal.min_contract_length.value,
    );
  },
);
export default store;
